import { render, staticRenderFns } from "./BaseHeaderVisaoGeral.vue?vue&type=template&id=21a68898&scoped=true&lang=pug"
import script from "./BaseHeaderVisaoGeral.vue?vue&type=script&lang=js"
export * from "./BaseHeaderVisaoGeral.vue?vue&type=script&lang=js"
import style0 from "./BaseHeaderVisaoGeral.vue?vue&type=style&index=0&id=21a68898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a68898",
  null
  
)

export default component.exports